/* Frankie & Belle, de metingen in het gat tussen ViewContent en AddToCart.
 *
 * WAAROM DIT BESTAAT. Na ronde een stond add to cart op nul bij 163 landingspaginaweergaven,
 * en tussen "de pagina laadde" en "ze legde iets in de wagen" zagen we helemaal niets. Dat is
 * tien schermen blind. Deze metingen zetten daar lampjes neer, zodat ronde twee vier antwoorden
 * geeft in plaats van een.
 *
 * WAT ER WEL EN NIET NAAR META GAAT. Twee soorten, en het verschil doet ertoe:
 *
 *   SizeSelected   gaat WEL naar Meta. Dit is de eerste echte beslissing op de pagina, en hij
 *                  kan later het optimalisatiedoel worden. Purchase haal je nooit op 50 per
 *                  week bij dit budget, deze wel.
 *   de rest        gaat ALLEEN het logboek in. Elke extra gebeurtenis in de pixel is ruis voor
 *                  het algoritme tenzij je erop optimaliseert. Deze zijn om te lezen, niet om
 *                  van te leren. De server beslist dat, zie DIAGNOSE in src/clients/capi.js.
 *
 * WAAROM GEEN fbq. De winkel meet via Shopify Customer Events, zie data/customer-events-pixel.js.
 * De pixel in het thema staat ALLEEN op de wachtwoordpagina, zie snippets/fb-pixel.liquid, want
 * twee pixels op dezelfde pagina telt elke PageView dubbel.
 *
 * EEN KEER PER PAGINAWEERGAVE PER SOORT. De vraag is "kwam ze zover", niet "hoe vaak klikte ze".
 * Drie klikken zouden het cijfer opblazen zonder de vraag beter te beantwoorden. De FAQ is de
 * uitzondering: daar telt elke andere vraag apart, want elke vraag is een ander bezwaar.
 *
 * Een Customer Events-pixel kan dit NIET doen: die draait in een afgeschermd iframe en ziet geen
 * kliks op de knoppen van het thema. Vandaar dat dit in het thema hoort.
 */
(function () {
  var INGANG = 'https://command.frankiebelle.com/api/capi/gebeurtenis';
  var gedaan = {};

  function koek(naam) {
    var m = document.cookie.match('(^|;)\\s*' + naam + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : undefined;
  }

  /* naam: de gebeurtenis. detail: wat er gekozen of geopend is. eenmalig: false laat hem
     vaker vuren, en dan onderscheidt de sleutel naam+detail. */
  function stuur(naam, detail, eenmalig) {
    var sleutel = eenmalig === false ? naam + '|' + detail : naam;
    if (gedaan[sleutel]) return;
    gedaan[sleutel] = true;

    var p = window.fbProductMeting || {};
    var body = {
      n: naam,
      id: 'fb_' + naam + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10),
      url: location.href,
      fbp: koek('_fbp'),
      fbc: koek('_fbc'),
      cd: {
        content_type: 'product',
        content_ids: p.id ? [String(p.id)] : undefined,
        content_name: p.naam,
        currency: p.valuta,
        value: p.prijs,
        detail: detail
      }
    };

    /* text/plain houdt het een EENVOUDIG verzoek, dus geen CORS-preflight. sendBeacon kan
       helemaal geen preflight sturen, dus met application/json faalt hij met ERR_FAILED en
       zie je niets, terwijl hij wel true teruggeeft. Zie valkuil 104. Dezelfde oplossing en
       dezelfde reden staan in data/customer-events-pixel.js, regel 89. */
    var rauw = JSON.stringify(body);
    try {
      var blob = new Blob([rauw], { type: 'text/plain;charset=UTF-8' });
      if (!navigator.sendBeacon || !navigator.sendBeacon(INGANG, blob)) {
        fetch(INGANG, { method: 'POST', body: rauw, keepalive: true,
          headers: { 'content-type': 'text/plain;charset=UTF-8' } }).catch(function () {});
      }
    } catch (e) { /* meten mag de winkel nooit ophouden */ }
  }
  window.fbMeet = stuur;

  function optieNaam(el) {
    var n = el && el.getAttribute && el.getAttribute('data-option-name');
    if (!n) {
      var fs = el && el.closest ? el.closest('fieldset, .product-form__input') : null;
      var lg = fs ? fs.querySelector('legend, label') : null;
      n = lg ? lg.textContent : '';
    }
    return String(n || '');
  }

  /* ---- 1 en 2: maat en kleur gekozen ---- */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el) return;
    if (el.tagName !== 'SELECT' && el.type !== 'radio') return;
    var naam = optieNaam(el);
    if (/\b(size|maat)\b/i.test(naam)) stuur('SizeSelected', el.value);
    else if (/\b(colour|color|kleur)\b/i.test(naam)) stuur('ColourSelected', el.value);
  }, true);

  /* ---- 3 en 4: maattabel en FAQ opengeklikt ----
     Allebei een <details>. De FAQ telt per vraag, want elke vraag is een ander bezwaar. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;

    if (d.closest('.fb-faq')) {
      var v = d.querySelector('summary');
      stuur('FaqOpened', v ? v.textContent.trim().slice(0, 90) : 'onbekend', false);
      return;
    }
    var s = d.querySelector('summary, .summary__title, h2');
    var t = s ? s.textContent.toLowerCase() : '';
    if (t.indexOf('size') >= 0 || t.indexOf('fit') >= 0) stuur('SizeChartOpened', t.trim().slice(0, 60));
  }, true);

  /* Dawn's accordeon is soms een button in plaats van een details, en dan komt er geen
     toggle-gebeurtenis. Vandaar ook een klik-luisteraar op de maatkop. */
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest ? e.target.closest('summary, .accordion__title, button') : null;
    if (!k) return;
    var t = (k.textContent || '').toLowerCase();
    if ((t.indexOf('size') >= 0 && t.indexOf('fit') >= 0) || t.indexOf('size chart') >= 0) {
      stuur('SizeChartOpened', t.trim().slice(0, 60));
    }
  }, true);

  /* ---- 5: de Klaviyo-aanmelding, als Lead ----
     Dit is de enige gebeurtenis waarvan we bij dit budget realistisch 50 per week halen, en
     het is ook het retargeting-publiek. Klaviyo roept dit op window om, niet op een element. */
  window.addEventListener('klaviyoForms', function (e) {
    if (e && e.detail && e.detail.type === 'submit') stuur('Lead', 'klaviyo-popup');
  });
})();
